import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

export default function IntNumberFormatInput(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalSeparator=","
            thousandSeparator="."
            isNumericString={true}
            decimalScale={0}
        />
    );
};

IntNumberFormatInput.propTypes = {
    inputRef: PropTypes.func,
    onChange: PropTypes.func.isRequired,
};